import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Plus, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

const blank = { name: "", body: "Io sottoscritto/a {nome}, nato/a a {luogo_nascita} il {data_nascita}, dichiaro che ", photos: "FOTO FRONTE\nFOTO RETRO" };

export const TemplatesDialog = ({ onClose }) => {
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/forms/templates").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    const body = { name: edit.name, body: edit.body, photos: edit.photos.split("\n").map((s) => s.trim()).filter(Boolean) };
    try { edit.id ? await api.put(`/forms/templates/${edit.id}`, body) : await api.post("/forms/templates", body); toast.success("Modello salvato"); setEdit(null); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (t) => {
    if (!window.confirm(`Eliminare il modello "${t.name}"? I moduli già creati restano.`)) return;
    try { await api.delete(`/forms/templates/${t.id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-2xl" data-testid="form-templates-dialog">
        <DialogHeader>
          <DialogTitle>Modelli dei moduli</DialogTitle>
          <DialogDescription>Nel testo puoi usare {"{nome}"}, {"{luogo_nascita}"}, {"{data_nascita}"}, {"{luogo}"} e {"{data}"}: vengono sostituiti con i dati del driver.</DialogDescription>
        </DialogHeader>
        {edit ? (
          <div className="space-y-3">
            <div className="space-y-1.5"><Label>Nome modello</Label><Input value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} data-testid="form-tpl-name" /></div>
            <div className="space-y-1.5"><Label>Testo</Label><Textarea rows={5} value={edit.body} onChange={(e) => setEdit({ ...edit, body: e.target.value })} data-testid="form-tpl-body" /></div>
            <div className="space-y-1.5"><Label>Foto richieste (una per riga, massimo 4)</Label><Textarea rows={3} value={edit.photos} onChange={(e) => setEdit({ ...edit, photos: e.target.value })} data-testid="form-tpl-photos" /></div>
            <div className="flex justify-end gap-2"><Button variant="outline" onClick={() => setEdit(null)}>Annulla</Button>
              <Button onClick={save} disabled={edit.name.trim().length < 2 || edit.body.trim().length < 5} data-testid="form-tpl-save">Salva</Button></div>
          </div>
        ) : (
          <>
            <Button size="sm" className="w-fit" onClick={() => setEdit(blank)} data-testid="form-tpl-add"><Plus className="mr-1 h-4 w-4" /> Nuovo modello</Button>
            <div className="divide-y rounded-lg border">
              {list.map((t) => (
                <div key={t.id} className="flex items-start gap-3 px-3 py-2" data-testid={`form-tpl-${t.id}`}>
                  <div className="min-w-0 flex-1"><p className="font-medium">{t.name}</p><p className="line-clamp-2 text-xs text-slate-500">{t.body}</p>
                    <p className="text-xs text-slate-400">Foto: {t.photos.join(", ") || "nessuna"}</p></div>
                  <Button size="sm" variant="ghost" onClick={() => setEdit({ ...t, photos: t.photos.join("\n") })} data-testid={`form-tpl-edit-${t.id}`}><Pencil className="h-4 w-4" /></Button>
                  <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => del(t)} data-testid={`form-tpl-delete-${t.id}`}><Trash2 className="h-4 w-4" /></Button>
                </div>
              ))}
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
